import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { colors } from '../../themes/typography';
import { getAlertTypeIcon, getAlertTypeText } from '../../utils/alertBadgeHelpers';

/**
 * Reusable AlertTypeBadge component
 * Displays a badge with alert type icon and tooltip in a pill, matching experiment badge styling
 */
const AlertTypeBadge = ({ alertType, t }) => {
  if (!alertType) return null;

  return (
    <Tooltip title={getAlertTypeText(alertType, t)} arrow>
      <Box sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: '20px',
        px: '6px',
        backgroundColor: 'rgba(59, 130, 246, 0.05)', // Same as experiment badge
        borderRadius: '10px',
        border: '1px solid rgba(59, 130, 246, 0.1)',
        cursor: 'help',
      }}>
        <Box sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: colors.text.secondary,
        }}>
          {getAlertTypeIcon(alertType)}
        </Box>
      </Box>
    </Tooltip>
  );
};

export default AlertTypeBadge;